var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6425 14.5205L10.4345 10.1442C11.5078 9.0678 12.1727 7.58383 12.1727 5.94721C12.1727 2.66775 9.50499 0 6.22553 0C2.94607 0 0.27832 2.66775 0.27832 5.94721C0.27832 9.22667 2.94607 11.8944 6.22553 11.8944C7.66504 11.8944 8.98617 11.3798 10.0159 10.526L14.2342 14.9131C14.2897 14.9711 14.3639 15 14.4383 15C14.5091 15 14.5797 14.9737 14.6346 14.921C14.7473 14.8125 14.7507 14.6333 14.6425 14.5205ZM6.22553 11.328C3.25844 11.328 0.844721 8.9143 0.844721 5.94721C0.844721 2.98012 3.25844 0.566401 6.22553 0.566401C9.19262 0.566401 11.6063 2.98012 11.6063 5.94721C11.6063 8.9143 9.19234 11.328 6.22553 11.328Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5287b5790009504821137a87af1d2684.svg";
export { ForwardRef as ReactComponent };